// extracted by mini-css-extract-plugin
export default {"container":"AdvancedSearch_container__ICgwz","icon":"AdvancedSearch_icon__fpKO9","text":"AdvancedSearch_text__uxZrW"};